module.exports = __webpack_public_path__ + "static/img/top_line.279b6a97.png";